module.exports = __webpack_public_path__ + "img/linternet.a788993e.png";